import React, { memo, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import CommonButton from '../../../../../components/common-button/CommonButton';
import Icon from '../../../../../icons/Icon';
import { ICONS } from '../../../../../icons';
import WithLabel, { LABEL_STYLES } from '../../../../../components/with-label/WithLabel';
import ImportDataset from './ImportDataset';
import { deleteSelectedItems, importDataset } from '../../../../../redux/create-sonar/createSonarActions';
import ConfirmationModal from '../../../../../components/confirmation-modal/ConfirmationModal';
import DeleteLabel from '../../../../projects-list/components/DeleteLabel';

import scss from '../SonarCreationForm.module.scss';

const DatasetButtons = ({ submitting, onAddDataset }) => {
  const { t } = useTranslation('projects');
  const dispatch = useDispatch();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const dataset = useSelector((state) => state.createSonar.dataset);

  const {
    input: { value: projectNameValue },
  } = useField('projectName');

  const isDeleteDisabled = !dataset.filter(({ isSelected }) => isSelected).length;

  const handleAddDataset = useCallback(() => {
    onAddDataset();
  }, [onAddDataset]);

  const handleOpenDeleteModal = () => {
    setIsDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteSelectedDataset = useCallback(() => {
    dispatch(deleteSelectedItems());
  }, [dispatch]);

  const handleImportDataset = useCallback(
    (file) => {
      dispatch(importDataset(file));
    },
    [dispatch],
  );

  return (
    <>
      <WithLabel variant={LABEL_STYLES.ALIGNED} label={`${t('dataset')}:`} isBold extraClassName={scss.inputRow}>
        <div className={scss.datasetActions}>
          <CommonButton styleColor='secondary' onClick={handleAddDataset}>
            <Icon icon={ICONS.CirclePlus} />
            {t('add')}
          </CommonButton>

          <CommonButton styleColor='secondary' onClick={handleOpenDeleteModal} disabled={isDeleteDisabled}>
            <Icon icon={ICONS.Delete} />
            {t('delete')}
          </CommonButton>

          <ImportDataset
            isLoading={submitting}
            disabled={submitting || !projectNameValue}
            onSubmit={handleImportDataset}
          />
        </div>
      </WithLabel>

      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        onCancel={handleCloseDeleteModal}
        onConfirm={handleDeleteSelectedDataset}
        subLabel={<DeleteLabel name={t('selectedDomains')} />}
      />
    </>
  );
};

export default memo(DatasetButtons);
